// extracted by mini-css-extract-plugin
export default {"container":"Taxi_container__u+6ij","posts_box":"Taxi_posts_box__DtN6P","progressContainer":"Taxi_progressContainer__NDPzs","datagrid_container":"Taxi_datagrid_container__OSeGu"};